import apiTamboUrl from "@/services/api";

export default {
  namespaced: true,
  state: {
    compras: [],
    loading: false,
    error: null,
  },
  getters: {
    compras: (s) => s.compras,
    loading: (s) => s.loading,
    error: (s) => s.error,
  },
  mutations: {
    setCompras(state, data) {
      state.compras = data;
    },
    setLoading(state, v) {
      state.loading = v;
    },
    setError(state, v) {
      state.error = v;
    },
    clearState(state) {
      state.compras = [];
      state.error = null;
    },
  },
  actions: {
    async getCompras({ commit }, params = {}) {
      commit("setLoading", true);
      try {
        const { data } = await apiTamboUrl.get("/compra-animales/", { params });
        commit("setCompras", data);
      } catch (e) {
        commit("setError", e.message);
      } finally {
        commit("setLoading", false);
      }
    },

    async registrarCompra({ dispatch }, payload) {
      const { data } = await apiTamboUrl.post("/compra-animales/", payload);
      await dispatch("getCompras");
      return data;
    },

    async actualizarCompra({ dispatch }, { compraId, payload }) {
      const { data } = await apiTamboUrl.patch(
        `/compra-animales/${compraId}`,
        payload
      );
      await dispatch("getCompras");
      return data;
    },

    async registrarPesaje({ commit }, { animalId, payload }) {
      const { data } = await apiTamboUrl.post(
        `/compra-animales/pesaje/${animalId}`,
        payload
      );
      return data;
    },

    async getHistorialPesajes({ commit }, animalId) {
      const { data } = await apiTamboUrl.get(
        `/compra-animales/pesajes/${animalId}`
      );
      return data;
    },

    async registrarEnfermedad({ commit }, { animalId, payload }) {
      const { data } = await apiTamboUrl.post(
        `/compra-animales/enfermedad/${animalId}`,
        payload
      );
      return data;
    },

    async getHistorialAnimal({ commit }, animalId) {
      const { data } = await apiTamboUrl.get(
        `/compra-animales/historial/${animalId}`
      );
      return data;
    },

    async registrarMuerte({ commit }, { animalId, payload }) {
      const { data } = await apiTamboUrl.post(
        `/compra-animales/muerte/${animalId}`,
        payload
      );
      return data;
    },

    async confirmarCapado({ commit }, animalId) {
      const { data } = await apiTamboUrl.post(
        `/compra-animales/capado/${animalId}`
      );
      return data;
    },

    async controlSanitario({ commit }, { animalId, payload }) {
      const { data } = await apiTamboUrl.post(
        `/compra-animales/control-sanitario/${animalId}`,
        payload
      );
      return data;
    },
    async registrarCompraBulk({ dispatch }, payload) {
      const { data } = await apiTamboUrl.post("/compra-animales/bulk", payload);
      await dispatch("getCompras");
      return data;
    },

    async cargaInicial({ dispatch }, payload) {
      const { data } = await apiTamboUrl.post(
        "/compra-animales/carga-inicial",
        payload
      );
      await dispatch("getCompras");
      return data;
    },
  },
};
